import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  PHONE: `${cleanedFilename(__filename)}-phone`,
  NAME: `${cleanedFilename(__filename)}-name`,
};
